import { render, staticRenderFns } from "./ProviderServiceManager.vue?vue&type=template&id=270763cd&scoped=true"
import script from "./ProviderServiceManager.vue?vue&type=script&lang=js"
export * from "./ProviderServiceManager.vue?vue&type=script&lang=js"
import style0 from "./ProviderServiceManager.vue?vue&type=style&index=0&id=270763cd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270763cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270763cd')) {
      api.createRecord('270763cd', component.options)
    } else {
      api.reload('270763cd', component.options)
    }
    module.hot.accept("./ProviderServiceManager.vue?vue&type=template&id=270763cd&scoped=true", function () {
      api.rerender('270763cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/contract/components/ProviderServiceManager.vue"
export default component.exports